import { render } from "./interface_language_switcher.vue?vue&type=template&id=30d5e29c"
import script from "./interface_language_switcher.vue?vue&type=script&lang=js"
export * from "./interface_language_switcher.vue?vue&type=script&lang=js"

import "./interface_language_switcher.vue?vue&type=style&index=0&id=30d5e29c&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__